import React, { useContext, useEffect, useState } from "react";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import {
  rcTreeToInboundTemplate,
  rcTreeToOutboundTemplate,
  rcTreeToOutboundXML,
  rcTreeToWorkflowTemplate,
} from "../../../utils/rctreeDataConversion";
import { useDispatch, useSelector } from "react-redux";
import NtwAlert from "../NewTemplateWizard/NtwContentOptions/NtwAlert";
import { api } from "../../../redux/api";

function DownloadTemplate({ open , toggle}) {
  const [alert, setAlert] = useState({ open: false,message: '',type: 'success' });
  const parentScreen = useContext(ParentScreenCtx);
  const { account } = useSelector((state) => state.queryParams);
  const { leftTree, rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const leftSelectedNode = leftTree.tree.body.selectedNode;
  const { treeData } = useSelector((state) => state);
  const { unsavedTemplates } = useSelector((state) => state.treeData);
  const dispatch = useDispatch()
  const ibData = treeData?.inbound?.rightTree?.tree;
  const obData = treeData?.outbound?.rightTree?.tree;
  const initialFetchData = treeData?.outbound?.rightTree?.initialFetchData;// for Outbound XML template
  const wfData = treeData?.workflow?.rightTree.tree;

  // Create unsaved templates array based on current screen
  const getUnsavedArr = () => {
    if (parentScreen === 'inbound') {
      return unsavedTemplates.inbound_templates.map(o => `${o.workflow_group}/${o.template}`);
    }
    if (parentScreen === 'outbound') {
      return unsavedTemplates.outbound_templates.map(o => `${o.workflow_group}/${o.template}`);
    }
    if (parentScreen === 'workflow') {
      return unsavedTemplates.workflow.map(o => `${o.workflow_group}/${o.template}`);
    }
    return [];
  };

  // Check if current template is unsaved
  const isTemplateUnsaved = () => {
    const unsavedArr = getUnsavedArr();
    const templatePath = `${leftSelectedNode?.workflowGroup}/${leftSelectedNode?.title}`;
    return unsavedArr.includes(templatePath);
  };
  // Local translation functions for unsaved templates (uses in-memory data)
  const localTranslationFunctionMap = {
    inbound: {
      func: rcTreeToInboundTemplate,
      args: [ibData], 
    },
    outbound: {
      func: treeData.outbound.rightTree.tree.templateHeader.FILETYPE === "XML"
        ? rcTreeToOutboundXML
        : rcTreeToOutboundTemplate,
      args: treeData.outbound.rightTree.tree.templateHeader.FILETYPE === "XML"
        ? [obData, initialFetchData] 
        : [obData], 
    },
    workflow: {
      func: rcTreeToWorkflowTemplate,
      args: [wfData], 
    },
  };
  
  // API translation functions for saved templates (fetches from server)
  const apiTranslationFunctionMap = {
    inbound:{
      func:"getInboundTemplateData",
      args:{
        account: account,
        workflowGroupName: leftSelectedNode?.workflowGroup,
        templateName: leftSelectedNode?.title,
      }
    },
    outbound:{
      func:"getOutboundTemplateData",
      args:{
        account: account,
        workflowGroupName: leftSelectedNode?.workflowGroup,
        templateName: leftSelectedNode?.title,
      }
    },
    workflow:{
      func:"getWorkflow",
      args:{
        account:account,
        workflow_group_name: leftSelectedNode?.workflowGroup,
        workflow_name: leftSelectedNode?.title,
      }
    }
  }
  useEffect(() => {
    if (open) {
      const handleDownload = (data, fileName) => {
        if (!data || rightTree.fetchError) {
          setAlert({open:true, message: 'No data found to download', type: 'error'});
          return;
        }
  
        // Convert JSON data to a string
        const jsonString = JSON.stringify(data, null, 2);
  
        // Create a Blob from JSON
        const blob = new Blob([jsonString], { type: "application/json" });
  
        // Create a download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
  
        // Trigger the download
        document.body.appendChild(a);
        a.click();
  
        // Cleanup
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
  
        setAlert({open:true, message: 'Template downloaded successfully', type: 'success'});
        setTimeout(() => {
          toggle();
        }, 2000);
      };
  
      // Check if template is unsaved and use appropriate translation function map
      const useLocalTranslation = isTemplateUnsaved();
      const selectedTranslationMap = useLocalTranslation ? localTranslationFunctionMap : apiTranslationFunctionMap;
      const translationEntry = selectedTranslationMap[treeData.currentScreen];
  
      if (!translationEntry) {
        console.error(`Invalid screen: ${treeData.currentScreen}`);
        return;
      }
  
      const { func, args } = translationEntry;
      
      if (useLocalTranslation) {
        // Use local translation functions for unsaved templates
        const templateJSON = func(...args);
        handleDownload(templateJSON, `${leftSelectedNode?.title}.json`);
      } else {
        // Use API calls for saved templates
        let templateJSON = {};
        dispatch(api.endpoints[func].initiate(args)).then((res) => {
          if(res && res.data){
            templateJSON = res.data;
            handleDownload(templateJSON, `${leftSelectedNode?.title}.json`);
          } else {
            setAlert({open:true, message: 'No data found to download', type: 'error'});
            setTimeout(() => {
              toggle();
            }, 2000);
          }
        });
      }

  
    }
  }, [open]);

  return (
    <>
      <NtwAlert
        open={alert.open}
        message={alert.message}
        onClose={() => setAlert({...alert, open:false})}
        type={alert.type}
      />
    </>
  );
}

export default DownloadTemplate;
